import React from 'react';
import { Button } from 'antd';
import { PDFDownloadLink } from '@react-pdf/renderer';
import MyDocument from './documentGenerate';
import { BRImages } from '../../assets/imgs';

const DownloadButton = ({ title, content, paragraphs = [], isFaithOfAmendment = false }) => {
  return (
    <PDFDownloadLink
      document={
        <MyDocument
          title={title}
          content={content}
          paragraphs={paragraphs}
          isFaithOfAmendment={isFaithOfAmendment}
        />
      }
      fileName={title + '.pdf'}
      style={{ textDecoration: 'none' }}
    >
      {({ loading }) =>
        loading ? (
          'Preparing document...'
        ) : (
          <Button className='collapse-download-btn shadow-none border-none poppins-16-medium pl-0'>
            <img
              src={BRImages.MediaPlayerImages.AudioDownloadIcon}
              alt='download-icon'
              className='download-icon'
            />
            Download E-book
          </Button>
        )
      }
    </PDFDownloadLink>
  );
};

export default DownloadButton;
